const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Moment } from './Moment';
import * as telegram from "./telegram"
import * as utils from "./utils"
import { Account } from './Account';

export type sortOrderTypes = 'FMV_DESC' | 'FMV_ASC' | 'OfferPrice_DESC' | 'OfferPrice_ASC' | 'OfferDate_DESC' | 'OfferDate_ASC' | 'BestOffer_ASC' | 'BestOffer_DESC' | 'Player_ASC' | 'Team_ASC'
export enum filterTypes {
  Made = 1, Received = 2
}

export class MomentOffered extends Moment {
  public offerDate: Date = null
  public offerPrice: number = null
  public buyerAddress: string = null
  public buyerUsername: string = null
  public buyerImageURL: string = null
  public isEditionOffer: boolean = null   // Aug 25, 2022
  public lowAskForEdition: number = null
  public numOwned: number = null          // Sept 16, 2022

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  // just for processing, not for client
  private offer: any = null

  constructor(po?: object) {
    super(po)
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (typeof this.offerDate === 'string') this.offerDate = new Date(this.offerDate)
  }

  public isSafe(): boolean {
    if (!super.isSafe()) return false
    if (this.offer) return false
    return true
  }
}
